module.exports = __webpack_public_path__ + "media/Lock.a4586262.webm";